var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGolfCourse = function SvgGolfCourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "golf_course_svg__a",
    width: 24,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .5h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#golf_course_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M19.727 21.548c-.429 0-.793-.151-1.093-.453-.3-.301-.449-.666-.449-1.095 0-.429.15-.794.45-1.096.3-.301.663-.452 1.092-.452.433 0 .799.15 1.098.45.3.3.45.665.45 1.098 0 .433-.15.799-.45 1.098-.3.3-.665.45-1.098.45M10 22.685c-1.719 0-3.18-.214-4.382-.641-1.202-.428-1.804-.942-1.804-1.544 0-.407.286-.777.858-1.109.572-.332 1.318-.601 2.238-.809V20.5h2V2.255L17.4 6.4l-6.31 3.255v8.722c1.477.095 2.695.336 3.655.722.96.386 1.44.853 1.44 1.4 0 .579-.59 1.087-1.768 1.527-1.178.44-2.651.66-4.417.66"
  }))));
};
export default SvgGolfCourse;